"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixpanelEventType = void 0;
var MixpanelEventType;
(function (MixpanelEventType) {
    MixpanelEventType["ORGANISATION_CREATED"] = "Organisation Created";
    MixpanelEventType["ORGANISATION_TERMS_APPROVED"] = "Organisation Terms Approved";
    MixpanelEventType["BRAND_CREATED"] = "Brand Created";
    MixpanelEventType["BRAND_ASSETS"] = "Brand Assets";
    MixpanelEventType["USER_INVITED"] = "User Invited";
    MixpanelEventType["USER_CREATED_FROM_INVITE"] = "User Created From Invite";
    MixpanelEventType["USER_SESSION"] = "User Session";
    MixpanelEventType["SIGN_UP_VISIT"] = "Sign Up Visit";
    MixpanelEventType["SIGN_UP_COMPLETED"] = "Sign Up Completed";
    MixpanelEventType["GAME_CREATED"] = "Game Created";
    MixpanelEventType["GAME_SETTINGS"] = "Game Settings";
    MixpanelEventType["GAME_ACTIVATED"] = "Game Activated";
    MixpanelEventType["GAME_LINK_COPIED"] = "Game Link Copied";
    MixpanelEventType["GC_CREATED"] = "GC: Created";
    MixpanelEventType["GC_LINK_COPIED"] = "GC: Link Copied";
    MixpanelEventType["GC_MODULE_CREATED"] = "GC: Module Created";
    MixpanelEventType["GC_GAME_ADDED"] = "GC: Game Added";
    MixpanelEventType["GC_REWARD_ADDED"] = "GC: Reward Added";
    MixpanelEventType["LINK_CREATED"] = "Link Created";
    MixpanelEventType["UPGRADE_REQUEST_SENT"] = "Upgrade Request Sent";
    MixpanelEventType["GAME_DESIGN"] = "Game Design";
    MixpanelEventType["PREVIEW_DESIGN"] = "Preview Design";
    MixpanelEventType["GC_PREVIEW_DESIGN"] = "GC: Preview Design";
})(MixpanelEventType || (exports.MixpanelEventType = MixpanelEventType = {}));
